export default {
  "APP_SELECT_PRODUCT_VIEW": "",
  "APP_THRESHOLD_UPDATES_VIEW": "",
  "APP_SAVE_THRESHOLD_VIEW": "COMMON_ADMIN",
  "APP_JOB_VIEW": "",
  "APP_JOB_UPDATE": "COMMON_ADMIN",
  "APP_THRESHOLD_RULE_UPDATE": "COMMON_ADMIN",
} as any 